import React from 'react';
import './prepareTo.css';

export default class PrepareTo extends React.Component {
    render() {
        return (
            <div className='prepareTo'>
                <div className='container prepareTo-wrap'>
                    <div className='prepareTo-upper'>
                        <div className="prepareTo-item">
                            <h5 className="prepareTo-item-title">NEAR - Layer 1 using Rust smartcontracts</h5>
                        </div>
                        <div className="prepareTo-item">
                            <h5 className="prepareTo-item-title">Cross-chain bridges</h5>
                        </div>
                        <div className="prepareTo-item hidden-pc">
                            <h5 className="prepareTo-item-title">Testing for blockchain</h5>
                        </div>
                        <div className="prepareTo-item">
                            <h5 className="prepareTo-item-title">Web3 development for Javascript and Python</h5>
                        </div>
                        <div className="prepareTo-item">
                            <h5 className="prepareTo-item-title">Ethereum scaling solutions</h5>
                        </div>
                    </div>
                    <div className='prepareTo-mid'>
                        <h4 className='prepareTo-title'><span>Prepare yourself to </span><br />web 3</h4>
                    </div>
                    <div className='prepareTo-lower'>
                        <div className="prepareTo-item hidden-mob">
                            <h5 className="prepareTo-item-title">Testing for blockchain</h5>
                        </div>
                        <div className="prepareTo-item">
                            <h5 className="prepareTo-item-title">Safety audit of smart contracts</h5>
                        </div>
                        <div className="prepareTo-item">
                            <h5 className="prepareTo-item-title">Scalability with Layer 2.0</h5>
                        </div>
                        <div className="prepareTo-item">
                            <h5 className="prepareTo-item-title">Ether.js and Web3.js, oo7.js, Alchemy Web3</h5>
                        </div>
                        <div className="prepareTo-item">
                            <h5 className="prepareTo-item-title">Solana - Layer 1 using Rust C, C++ for smartcontracts</h5>
                        </div>
                        {/* <div className="prepareTo-item">
                            <h5 className="prepareTo-item-title">smart contract workshops</h5>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}